import Link from "next/link";
import { PropsWithChildren } from "react";
import { loraItalic } from "@/app/styles/fonts";
interface NavLinkProps {
  route: string;
  service?: boolean;
  onClick?: () => void;
  text?: string;
  border?: boolean;
  isCaption?: boolean;
  styles?: string;
}

//TODO: FIX THIS MESS LOL

export function NavLink({
  route,
  service,
  onClick,
  text,
  border,
  isCaption,
  styles,
  children,
}: PropsWithChildren<NavLinkProps>) {
  return (
    <Link
      className={`
        ${styles && styles}
        ${
          service
            ? "focus:outline-none focus-visible:ring focus-visible:ring-olive focus-visible:ring-offset-4 hover:text-gold hover:underline"
            : `focus:outline-none ${
                !children && `p-2`
              } hover:text-gold hover:underline`
        } ${
        border &&
        `${loraItalic.className} border border-olive text-olive text-xl p-2 mb-4 hover:border-white hover:text-gold hover:bg-white focus:outline-none focus-visible:ring focus-visible:underline focus-visible:ring-white focus-visible:bg-white focus-visible:text-gold`
      } ${
        isCaption &&
        "self-baseline focus:outline-none focus-visible:ring focus-visible:ring-olive px-0 w-full text-left"
      } `}
      href={"/" + route.replace(/\s+/g, "").toLowerCase()}
      onClick={onClick}
    >
      {children && children}
      {text ? text : route}
    </Link>
  );
}
